export class GenericIdbaRequestModel {
    program: string;
    procedure: string;
    parameters: {};

    constructor(){
        this.procedure = "main"; 
        this.parameters = {} 
    };
}
